export function Page({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <main
      className={`flex flex-1 flex-col p-2 md:h-full md:overflow-clip ${className || ''}`}
    >
      <div className="flex min-h-0 grow flex-col rounded-[10px] bg-white md:overflow-clip">
        {children}
      </div>
    </main>
  )
}
